export default __webpack_public_path__ + "static/ekstruzija-33054bc2529b62a1d309249b17645a92.jpg";